import { Outlet } from 'react-router-dom';

const PartnersOutlet = () => {
  return <Outlet />;
};

export default PartnersOutlet;
